import { Alert, AlertTitle, Button } from '@mui/material'
import { Warning } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import { useSubscription, getDaysRemaining, isInGracePeriod, isExpired } from '../hooks/useSubscription'

export function SubscriptionBanner() {
  const navigate = useNavigate()
  const { data: sub } = useSubscription()

  if (!sub) return null

  if (isExpired(sub)) {
    return (
      <Alert severity="error" icon={<Warning />} sx={{ mb: 2, borderRadius: 0 }}
        action={<Button color="inherit" size="small" onClick={() => navigate('/billing')}>Renew Now</Button>}>
        <AlertTitle>Subscription Expired</AlertTitle>
        Your subscription has expired. All features are disabled except billing. Please renew to continue.
      </Alert>
    )
  }

  if (isInGracePeriod(sub)) {
    const daysLeft = getDaysRemaining(sub)
    return (
      <Alert severity="warning" icon={<Warning />} sx={{ mb: 2, borderRadius: 0 }}
        action={<Button color="inherit" size="small" onClick={() => navigate('/billing')}>Renew Now</Button>}>
        <AlertTitle>Subscription Expiring</AlertTitle>
        Your subscription expired. You have {3 - Math.max(0, -daysLeft)} day(s) left before access is restricted. Renew now to avoid interruption.
      </Alert>
    )
  }

  // Show warning when < 7 days remaining
  const days = getDaysRemaining(sub)
  if (days > 0 && days <= 7) {
    return (
      <Alert severity="info" sx={{ mb: 2, borderRadius: 0 }}
        action={<Button color="inherit" size="small" onClick={() => navigate('/billing')}>Renew</Button>}>
        Your subscription expires in {days} day{days === 1 ? '' : 's'}.
      </Alert>
    )
  }

  return null
}
